import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import moment from 'moment';

class Component extends BaseComponent {
    constructor() {
        super();

        this.setState({
            nameError: null,
            birthdateError: null,
            privacyPolicyError: null,
        });
    }

    componentDidUpdate() {
        const modalInner = document.querySelector('signup-modal .modal-inner');
        const top = window.pageYOffset + (window.innerHeight / 2) - (modalInner.offsetHeight / 2);
        modalInner.style.top = top + 'px';
    }

    render({ isOpen, buttonText }) {
        return (
            <signup-modal class={isOpen ? 'open' : ''}>
                <a class='backdrop' onClick={this.close} />
                <aside class='modal-inner'>
                    <a class='modal-close-button' onClick={this.close} />
                    {this.renderHeader()}
                    <form onSubmit={this.submit} onKeyUp={this.keyup}>
                        <fieldset class='name-field'>
                            <label>
                                Your Name
                                <input
                                  data-action='Type-Name'
                                  data-category='Three-Card-Reading'
                                  data-label='Signup'
                                  data-ga-event
                                  name='user_name'
                                  type='text'
                                />
                                {this.renderError(this.state.nameError)}
                            </label>
                        </fieldset>
                        <fieldset class='birthdate-field'>
                            <label>
                                Your Birth Date
                                <input
                                  data-action='Type-BirthDate'
                                  data-category='Three-Card-Reading'
                                  data-label='Signup'
                                  data-ga-event
                                  max={moment(moment().subtract(13, 'year')).format('YYYY-MM-DD')}
                                  min='1900-01-01'
                                  name='birth_date'
                                  type='date'
                                />
                                {this.renderError(this.state.birthdateError)}
                            </label>
                        </fieldset>
                        <fieldset class='checkbox'>
                            <label>
                                <input
                                  data-action='Select-Subscribe-DHE'
                                  data-category='Three-Card-Reading'
                                  data-label='Signup'
                                  data-ga-event
                                  name='dh_optin'
                                  type='checkbox'
                                  value='1'
                                />
                                Get my FREE daily horoscope emails
                            </label>
                            <label>
                                <input
                                  data-action='Select-Subscribe-WRS'
                                  data-category='Three-Card-Reading'
                                  data-label='Signup'
                                  data-ga-event
                                  name='wrs_optin'
                                  type='checkbox'
                                  value='1'
                                />
                                Get my FREE weekly horoscope emails
                            </label>
                            {this.renderPPC()}
                        </fieldset>
                        <input type='hidden' name='special_offer_optin' value='1' />
                        <div class='clear' />
                        <button class='button button-warning'>{buttonText}</button>
                        {this.renderTOS()}
                    </form>
                </aside>
            </signup-modal>
        );
    }

    renderPPC = () => {
        if (!this.props.ppc) {
            return (
                <label class={this.state.privacyPolicyError ? 'error' : ''}>
                    <input
                      data-action='Select-Privacy-Policy-Terms-of-Use'
                      data-category='Three-Card-Reading'
                      data-label='Signup'
                      data-ga-event
                      name='privacy_policy'
                      type='checkbox'
                      value='1'
                    />
                    I agree to Tarot.com's updated <a href='/privacy-policy' target='_blank'>Privacy Policy
                    </a> and <a href='/terms-of-use' target='_blank'>Terms of Use</a>.
                    {this.renderError(this.state.privacyPolicyError)}
                </label>
            );
        }

        return null;
    }

    renderTOS = () => {
        if (this.props.ppc) {
            return (
                <p class='tos-warning'>
                    By continuing, you accept our&nbsp;
                    <a
                      class='text-link-undecorated'
                      data-action='goto_privacy_policy'
                      data-category='Three-Card-Reading'
                      data-label='Signup'
                      data-ga-event='true'
                      href='/privacy-policy'
                      target='_blank'
                    >
                        Privacy Policy
                    </a>
                    &nbsp;and&nbsp;
                    <a
                      class='text-link-undecorated'
                      data-action='goto_terms_of_use'
                      data-category='Three-Card-Reading'
                      data-label='Signup'
                      data-ga-event='true'
                      href='/terms-of-use'
                      target='_blank'
                    >
                        Terms of Use
                    </a>
                    .
                </p>
            );
        }

        return null;
    }

    renderError = (errorText) => {
        if (errorText) {
            return (
                <div class='form-error'>{errorText}</div>
            );
        }

        return null;
    }

    close = (e) => {
        e.preventDefault();
        this.props.routeTo('');
    }

    submit = (e) => {
        e.preventDefault();
        const form = e.target;
        const user_name = form.querySelector('input[name="user_name"]').value;

        let birth_date = form.querySelector('input[name="birth_date"]').value;
        let privacyPolicyError = null;

        const nameError = user_name.trim().length ? null : 'Please enter your name.';
        const birthdateError = this.validateBirthdate(birth_date);

        if (!this.props.ppc) {
            const pp = form.querySelector('input[name="privacy_policy"]').checked;
            privacyPolicyError = pp ? null : 'Please accept before continuing.';
        }

        this.setState({
            nameError: nameError,
            birthdateError: birthdateError,
            privacyPolicyError: privacyPolicyError,
        });

        let subscribe_lists = ['ipe'];

        if (form.querySelector('input[name="dh_optin"]').checked) {
            subscribe_lists.push('dailyhoroscope');
        }

        if (form.querySelector('input[name="wrs_optin"]').checked) {
            subscribe_lists.push('weekly_love');
        }

        if (!nameError && !birthdateError && !privacyPolicyError) {
            birth_date = moment(birth_date).format('YYYY-MM-DD');
            this.props.userSignup({
                user_name: user_name,
                cur_fname: user_name,
                display_name: user_name,
                birth_date: birth_date,
                email: this.props.user.email,
                password: this.props.user.password,
                password_verify: this.props.user.password,
                signup_gateway: this.props.upc || this.props.compatSlant || '#signup',
                signup_url: window.location.href,
                account_type_id: 1,
                timezone: (new Date().getTimezoneOffset() / 60) * -1,
                welcome_email: true,
                privacy_policy: true,
                subscribe_lists: subscribe_lists,
                signup_bonus: true,
                award_pfero: true,
            });
        }
    }

    keyup = (e) => {
        if (e.keyCode == 27 && this.props.isOpen) {
            this.props.routeTo('');
        }
    }

    renderHeader = () => {
        if (this.props.product) {
            return (
                <header>
                    <h1>{this.props.h1Text}</h1>
                    <h2>Help us personalize your experience…</h2>
                </header>
            );
        }

        return (
            <header>
                <h1>So nice to see you!</h1>
                <h2>Join our community</h2>
            </header>
        );
    }

    validateBirthdate = (birthdate) => {
        if (!birthdate) {
            return 'Please enter your birth date';
        } else if (birthdate.match(/^\d{2,4}-\d{2}-\d{2}$/)){
            return null;
        } else if (birthdate.match(/^\d{1,2}\/\d{1,2}\/\d{2,4}$/)) {
            return null;
        } else if (birthdate.match(/^\d{2}-\d{2}-\d{2,4}$/)) {
            return null;
        }

        return 'Birthday format is mm/dd/yyyy';
    }
}

const mapStateToProps = (state) => ({
    isOpen: state.route === 'signup',
    buttonText: state.product ? `Get my ${state.product.type}!` : 'Sign Up!',
    product: state.product,
    user: state.user,
    upc: state.product && state.product.teeup && state.product.teeup.code,
    h1Text: state.product.type && state.product.type.match(/s$/)
        ? `Your ${state.product.type} Await!`
        : `Your ${state.product.type} Awaits!`,
    compatSlant: state['compatibility-chooser'] && state['compatibility-chooser'].slant
        ? `compat-tag-${state['compatibility-chooser'].slant}`
        : null,
    ppc: state.cookie && state.cookie.PRIVACY_POLICY_CONSENT,
});

const mapDispatchToProps = (dispatch) => ({
    routeTo: route => dispatch({ type: 'route:to', payload: route }),
    userSignup: payload => dispatch({ type: 'user:signup-api', payload: payload }),
    setCookie: payload => dispatch({ type: 'cookie:set', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/user/signup-modal.js